module.exports = __webpack_public_path__ + "static/pg-e88735732b8eedd3e4f35bb1621e2973.png";